import React, {useEffect, useState} from 'react';
import {Alert, Button, Card, Flex, FloatButton, Form, Input, message, Modal, Table} from "antd";
import {PlusOutlined, ReloadOutlined} from "@ant-design/icons";
import dayjs from "dayjs";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";




const Commodity_fenlei_UI = () => {


    document.title='商品分类'
const navigate=useNavigate();

let data_time=dayjs().unix();


    useEffect(() => {



        window.scrollTo(0, 0); // 每次页面加载时将滚动条位置重置到顶部

        setfetch_sort_shop_select_log({message: 'click', value: '', time: data_time})


    }, []);



    const [fetch_sort_shop_select_info, setfetch_sort_shop_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_sort_shop_select_log, setfetch_sort_shop_select_log] = useState({message: '', value: '', time: 0})
    const fetch_sort_shop = (e1: any) => {

        setfetch_sort_shop_select_log({message: 'click', value: '', time: data_time})



        setfetch_sort_shop_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }

const [table_date_s,settable_date_s]=useState({
    "message": 0,
    "value": "获取成功",
    "info": [
        {
            "id": "25",
            "uuid": "d5559622-7e95-4d45-ac49-35e9363a3528",
            "userid": null,
            "sort_name": "安卓手机",
            "created": "1733314450",
            "status": "en",
            "updated": "1733314493",
            "parent_uuid": "0",
            "country_code": "56888",
            "region_parent_id": null,
            "region_id": null,
            "row_num": null,
            "children": []
        }
    ]
})

const [return_data_fetch_sort_shop,setreturn_data_fetch_sort_shop]=useState({
  "message": 0,
  "value": "获取成功",
  "info": [
    {
      "id": "2",
      "uuid": "93386a13-82a4-4937-a7a2-1a3762c7206c",
      "userid": null,
      "sort_name": "健康保健",
      "created": null,
      "status": "en",
      "updated": null,
      "parent_uuid": "0",
      "country_code": "56888",
      "region_parent_id": null,
      "region_id": "6666",
      "row_num": "999",
      "children": []
    },
    {
      "id": "3",
      "uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
      "userid": null,
      "sort_name": "桶装",
      "created": null,
      "status": "en",
      "updated": null,
      "parent_uuid": "0",
      "country_code": "56888",
      "region_parent_id": null,
      "region_id": "6666",
      "row_num": "999",
      "children": [
        {
          "id": "4",
          "uuid": "3c67f228-d947-449a-a2e3-9cedf27da004",
          "userid": null,
          "sort_name": "12",
          "created": "1729152105",
          "status": "en",
          "updated": null,
          "parent_uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
          "country_code": "56888",
          "region_parent_id": null,
          "region_id": null,
          "row_num": "999",
          "children": []
        }
      ]
    },
    {
      "id": "5",
      "uuid": "9a8dcd62-dc4c-415c-8b11-a3efd4494ebd",
      "userid": null,
      "sort_name": "11",
      "created": "1729152355",
      "status": "en",
      "updated": null,
      "parent_uuid": "0",
      "country_code": "56888",
      "region_parent_id": null,
      "region_id": null,
      "row_num": "999",
      "children": []
    }
  ]
});

    const fetch_sort_shop_body = new FormData();


    fetch_sort_shop_body.append('id', fetch_sort_shop_select_info.value1);

    fetch_sort_shop_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_sort_shop_body.append('time', String(fetch_sort_shop_select_info.time));

    fetch_sort_shop_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/sort_shop/fetch/fetch_sort_shop.php', {


                method: 'POST',
                body: fetch_sort_shop_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

                    //无需提示
                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

               setreturn_data_fetch_sort_shop(return_data);
                    settable_date_s(return_data)
                 //   settable_date_s(return_data.info.map((item:any)=>({key:item.uuid,name:item.sort_name,parent_uuid:item.parent_uuid,created:dayjs.unix(item.created).format('YYYY-MM-DD HH:mm:ss'),label:item.sort_name, children: item.children.length>0 ? item.children.map((itemd:any)=>({key:itemd.uuid,name:itemd.sort_name,created:dayjs.unix(item.created).format('YYYY-MM-DD HH:mm:ss'),label:itemd.sort_name})): null})))
                  //  setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_fenlei')


                    break

                          case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_fenlei')


                    break


            }

        }


        if(fetch_sort_shop_select_log.message!==''){

            data_async();
            setfetch_sort_shop_select_log({message:'',value:'',time:0})
        }
    }, [fetch_sort_shop_select_log]);


       const [add_tab_sub_info_modal_open, setadd_tab_sub_info_modal_open] = useState(false)

    const [add_tab_sub_info_select_info, setadd_tab_sub_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [add_tab_sub_info_select_log, setadd_tab_sub_info_select_log] = useState({message: '', value: '', time: 0})
    const add_tab_sub_info = (info: any) => {


            console.log(info)

        setadd_tab_sub_info_select_log({message: 'click', value: '', time: data_time})

        setadd_tab_sub_info_modal_open(true);

        setadd_tab_sub_info_select_info({value1: info.key, value2: '', value3: '', time: data_time})
    }


    const setadd_tab_sub_info_modal_oncancel = () => {

        setadd_tab_sub_info_modal_open(false);
    }


    const [add_tab_sub_info_modal_form]=Form.useForm();

    const add_tab_sub_info_modal_initialValues={




    }

    const [add_tab_sub_info_modal_onfinish_select_log,setadd_tab_sub_info_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

const [add_tab_sub_info_modal_onfinish_select_info,setadd_tab_sub_info_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const add_tab_sub_info_modal_onfinish = (e1:any) => {

let data_time=dayjs().unix();

        setadd_tab_sub_info_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
  setadd_tab_sub_info_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


const [return_data_add_tab_sub_info,setreturn_data_add_tab_sub_info]=useState({});

    const add_tab_sub_info_body = new FormData();


    add_tab_sub_info_body.append('finish_data', JSON.stringify(add_tab_sub_info_modal_onfinish_select_info.value1));

    add_tab_sub_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    add_tab_sub_info_body.append('time', String(add_tab_sub_info_modal_onfinish_select_info.time));

    add_tab_sub_info_body.append('action', 'add_node');

add_tab_sub_info_body.append('uuid', add_tab_sub_info_select_info.value1);

    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/sort_shop/insert/insert_sort_shop_sub.php', {


                method: 'POST',
                body: add_tab_sub_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setadd_tab_sub_info_modal_open(false)

 setreturn_data_add_tab_sub_info(return_data);

                         setfetch_sort_shop_select_log({message: 'click', value: '', time: data_time})
                 //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_fenlei')


                    break

                          case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_fenlei')


                    break


            }

        }


            if(add_tab_sub_info_modal_onfinish_select_log.message!==''){

   data_async();
            setadd_tab_sub_info_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [add_tab_sub_info_modal_onfinish_select_log]);




       const [add_table_sort_modal_open, setadd_table_sort_modal_open] = useState(false)

    const [add_table_sort_select_info, setadd_table_sort_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [add_table_sort_select_log, setadd_table_sort_select_log] = useState({message: '', value: '', time: 0})
    const add_table_sort = (e1: any) => {

        setadd_table_sort_select_log({message: 'click', value: '', time: data_time})

        setadd_table_sort_modal_open(true);

        setadd_table_sort_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setadd_table_sort_modal_oncancel = () => {

        setadd_table_sort_modal_open(false);
    }


    const [add_table_sort_modal_form]=Form.useForm();

    const add_table_sort_modal_initialValues={




    }

    const [add_table_sort_modal_onfinish_select_log,setadd_table_sort_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

const [add_table_sort_modal_onfinish_select_info,setadd_table_sort_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const add_table_sort_modal_onfinish = (e1:any) => {

let data_time=dayjs().unix();

        setadd_table_sort_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
  setadd_table_sort_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


const [return_data_add_table_sort,setreturn_data_add_table_sort]=useState({});

    const add_table_sort_body = new FormData();


    add_table_sort_body.append('finish_data', JSON.stringify(add_table_sort_modal_onfinish_select_info.value1));

    add_table_sort_body.append('userToken', String(Cookies.get('userToken_chattool')));

    add_table_sort_body.append('time', String(add_table_sort_modal_onfinish_select_info.time));

    add_table_sort_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/sort_shop/insert_m/insert_sort_shop.php', {


                method: 'POST',
                body: add_table_sort_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                   /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setadd_table_sort_modal_open(false)

 setreturn_data_add_table_sort(return_data);

                setfetch_sort_shop_select_log({message: 'click', value: '', time: data_time})
                 //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_fenlei')


                    break

                          case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_fenlei')


                    break


            }

        }


            if(add_table_sort_modal_onfinish_select_log.message!==''){

   data_async();
            setadd_table_sort_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [add_table_sort_modal_onfinish_select_log]);



       const [edit_tab_sub_info_modal_open, setedit_tab_sub_info_modal_open] = useState(false)

    const [edit_tab_sub_info_select_info, setedit_tab_sub_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [edit_tab_sub_info_select_log, setedit_tab_sub_info_select_log] = useState({message: '', value: '', time: 0})
    const edit_tab_sub_info = (e1: any) => {

        edit_tab_sub_info_modal_form.setFieldValue('sort_name',e1.name)

        setedit_tab_sub_info_select_log({message: 'click', value: '', time: data_time})

        setedit_tab_sub_info_modal_open(true);

        setedit_tab_sub_info_select_info({value1: e1.key, value2: '', value3: '', time: data_time})
    }


    const setedit_tab_sub_info_modal_oncancel = () => {

        setedit_tab_sub_info_modal_open(false);
    }


    const [edit_tab_sub_info_modal_form]=Form.useForm();

    const edit_tab_sub_info_modal_initialValues={




    }

    const [edit_tab_sub_info_modal_onfinish_select_log,setedit_tab_sub_info_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

const [edit_tab_sub_info_modal_onfinish_select_info,setedit_tab_sub_info_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const edit_tab_sub_info_modal_onfinish = (e1:any) => {

let data_time=dayjs().unix();

        setedit_tab_sub_info_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
  setedit_tab_sub_info_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


const [return_data_edit_tab_sub_info,setreturn_data_edit_tab_sub_info]=useState({});

    const edit_tab_sub_info_body = new FormData();

   edit_tab_sub_info_body.append('uuid', edit_tab_sub_info_select_info.value1);

    edit_tab_sub_info_body.append('finish_data', JSON.stringify(edit_tab_sub_info_modal_onfinish_select_info.value1));

    edit_tab_sub_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    edit_tab_sub_info_body.append('time', String(edit_tab_sub_info_modal_onfinish_select_info.time));

    edit_tab_sub_info_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/sort_shop/update/update_sort_shop_name.php', {


                method: 'POST',
                body: edit_tab_sub_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                  /*  message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setedit_tab_sub_info_modal_open(false)

 setreturn_data_edit_tab_sub_info(return_data);
                       setfetch_sort_shop_select_log({message:'11',value:'',time:data_time})
                 //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_fenlei')


                    break

                          case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_fenlei')


                    break


            }

        }


            if(edit_tab_sub_info_modal_onfinish_select_log.message!==''){

   data_async();
            setedit_tab_sub_info_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [edit_tab_sub_info_modal_onfinish_select_log]);





    const [delete_tab_info_modal_open, setdelete_tab_info_modal_open] = useState(false)

    const [delete_tab_info_select_info, setdelete_tab_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [delete_tab_info_select_log, setdelete_tab_info_select_log] = useState({message: '', value: '', time: 0})
    const delete_tab_info = (e1: any) => {

        setdelete_tab_info_select_log({message: 'click', value: '', time: data_time})

        setdelete_tab_info_modal_open(true);

        setdelete_tab_info_select_info({value1: e1.key, value2: '', value3: '', time: data_time})
    }


    const setdelete_tab_info_modal_oncancel = () => {

        setdelete_tab_info_modal_open(false);
    }


    const [delete_tab_info_modal_next_button_select_log,setdelete_tab_info_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const delete_tab_info_modal_next_button = () => {

let data_time=dayjs().unix();

        setdelete_tab_info_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


const [return_data_delete_tab_info,setreturn_data_delete_tab_info]=useState({});

    const delete_tab_info_body = new FormData();

   delete_tab_info_body.append('uuid', delete_tab_info_select_info.value1);


    delete_tab_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    delete_tab_info_body.append('time', String(delete_tab_info_modal_next_button_select_log.time));

    delete_tab_info_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


                 const data_await = await fetch('https://api.chatv2.leytcn.com/admin/sort_shop/delete_v/delete_sort_shop.php', {


                method: 'POST',
                body: delete_tab_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                  /*  message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setdelete_tab_info_modal_open(false)

 setreturn_data_delete_tab_info(return_data);
                       setfetch_sort_shop_select_log({message:'dd',value:'',time:data_time})
                //    setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_fenlei')


                    break

      case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_fenlei')


                    break

            }

        }


            if(delete_tab_info_modal_next_button_select_log.message!==''){

   data_async();
            setdelete_tab_info_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [delete_tab_info_modal_next_button_select_log]);





    return (<div style={{minHeight: '100%'}}>





        <Card>

            <div>


            </div>

            <p></p>


            <Table

                scroll={{ x: 'max-content' }}

                dataSource={table_date_s.message!==2000?[]:table_date_s.info.map((item:any)=>({key:item.uuid,name:item.sort_name,parent_uuid:item.parent_uuid,created:dayjs.unix(item.created).format('YYYY-MM-DD HH:mm:ss'),label:item.sort_name, children: item.children.length>0 ? item.children.map((itemd:any)=>({key:itemd.uuid,name:itemd.sort_name,created:dayjs.unix(item.created).format('YYYY-MM-DD HH:mm:ss'),label:itemd.sort_name})): null}))}

                   columns={[{
                title: '分类名称',
                dataIndex: 'name',
                key: 'name',

            }, {title: '创建时间', dataIndex: 'created', key: 'created'}, {
                title: '操作',
                dataIndex: '',
                key: '',
                width: 200,
                render: (text, record) => <div>{record.parent_uuid==='0' ?


                    <Flex gap="small" >

                        <label onClick={()=>add_tab_sub_info(record)}>添加子分</label>


                        <label onClick={()=>edit_tab_sub_info(record)}>编辑</label>

                           <label onClick={()=>delete_tab_info(record)}>删除</label>
                    </Flex>
                    : <Flex gap={'small'}>


                        <label onClick={()=>edit_tab_sub_info(record)}>编辑</label>


                        <label onClick={()=>delete_tab_info(record)}>删除</label>

                    </Flex>}</div>
            }]}/>

        </Card>

        <FloatButton.Group className="admin-float-actions">
            <FloatButton icon={<PlusOutlined/>} tooltip="新增分类" onClick={add_table_sort}/>
            <FloatButton icon={<ReloadOutlined/>} tooltip="刷新" onClick={fetch_sort_shop}/>
        </FloatButton.Group>




            <Modal open={delete_tab_info_modal_open} onCancel={setdelete_tab_info_modal_oncancel} footer={null} title={'是否确认删除？'}>


                <Alert type={'error'} message={'注意：删除当前分类，会把原有在此级的商品重置分类'}/>


                <p></p>
                <Button  onClick={delete_tab_info_modal_next_button}>

                    确认删除
                </Button>




                <Button style={{marginLeft:10}} onClick={setdelete_tab_info_modal_oncancel}>

                    取消
                </Button>


            </Modal>






            <Modal open={edit_tab_sub_info_modal_open} onCancel={setedit_tab_sub_info_modal_oncancel} footer={null} title={'编辑分类名'}>




                <Form form={edit_tab_sub_info_modal_form} initialValues={edit_tab_sub_info_modal_initialValues} onFinish={edit_tab_sub_info_modal_onfinish}>



                    <Form.Item name={'sort_name'} rules={[{message:'必填项',required:true}]}>

                        <Input placeholder={'分类名'}>



                        </Input>


                    </Form.Item>



                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft:10}} onClick={setedit_tab_sub_info_modal_oncancel}>取消</Button>

                </Form>


            </Modal>





            <Modal open={add_tab_sub_info_modal_open} onCancel={setadd_tab_sub_info_modal_oncancel} footer={null} title={'添加分类'}>




                <Form form={add_tab_sub_info_modal_form} initialValues={add_tab_sub_info_modal_initialValues} onFinish={add_tab_sub_info_modal_onfinish}>



                    <Form.Item name={'sort_name'} rules={[{message:'必填项',required:true}]}>

                        <Input placeholder={'分类名'}>



                        </Input>


                    </Form.Item>


                    <Alert type={'error'} message={'注意：添加二级分类后，会把原有在此级的商品重置分'}/>

                    <p></p>
                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft:10}} onClick={setadd_tab_sub_info_modal_oncancel}>取消</Button>

                </Form>


            </Modal>







            <Modal open={add_table_sort_modal_open} onCancel={setadd_table_sort_modal_oncancel} footer={null} title={'添加分类'}>




                <Form form={add_table_sort_modal_form} initialValues={add_table_sort_modal_initialValues} onFinish={add_table_sort_modal_onfinish}>



                    <Form.Item name={'table_sort_name'} rules={[{message:'必填项',required:true}]}>

                        <Input placeholder={'分类名'}>



                        </Input>


                    </Form.Item>



                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft:10}} onClick={setadd_table_sort_modal_oncancel}>取消</Button>

                </Form>


            </Modal>





    </div>)

}


export default Commodity_fenlei_UI;
